/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Late_Glad_Duck_StriveInputs */

const en_late_glad_duck_strive = /** @type {(inputs: Late_Glad_Duck_StriveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select segments to view results for specific groups of participants.`)
};

const de_late_glad_duck_strive = /** @type {(inputs: Late_Glad_Duck_StriveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie Segmente aus, um Ergebnisse für bestimmte Gruppen von Teilnehmern anzuzeigen.`)
};

/**
* | output |
* | --- |
* | "Select segments to view results for specific groups of participants." |
*
* @param {Late_Glad_Duck_StriveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const late_glad_duck_strive = /** @type {((inputs?: Late_Glad_Duck_StriveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Late_Glad_Duck_StriveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_late_glad_duck_strive(inputs)
	return de_late_glad_duck_strive(inputs)
});